/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from "vue-tsx-support";
import {Component} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"

@Component
export default class Keep extends Vue.Component<any> {
	render (h) {
		return (
			<keep-alive include={this.$store.state.layout.cache}>
				<router-view></router-view>
			</keep-alive>
		);
	}
}
